<template>
  <v-card>
    <v-card-title class="justify-center">
      <span v-if="form_type == 'addForm' " class="text-h5">{{ $t('Add Event') }}</span>
      <span v-if="form_type == 'editForm' " class="text-h5">{{ $t('Edit Event') }}</span>
      <span v-if="form_type == 'viewForm' " class="text-h5">{{ $t('Event') }}</span>
    </v-card-title>
    <v-card-text>


      <v-container>
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="primary"
          icon="mdi-weather-lightning"
        >

          <v-form>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-select 
                  v-if="form_type == 'addForm' || form_type == 'editForm'"
                  color="purple"
                  :items="yearList"
                  :item-value="item=>item.id"
                  :item-text="item=>item.name"
                  :label="$t('Event Year')"
                  v-model="disaster.year_id"
                  :hint="$t('Mandatory')"
                  :rules="selectRules"
                  persistent-hint
                >
                   <template v-slot:item="{ item }">
                    <div>{{ getTranslation(item.name) }}</div>
                  </template>
                </v-select>
                <div v-if="form_type == 'viewForm'">
                  <p class="font-weight-light">{{ $t('Event Year') }}</p>
                  <p class="text-h4 text--primary">{{ disaster.year.name }}</p>
                </div>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select 
                  v-if="form_type == 'addForm' || form_type == 'editForm'"
                  color="purple"
                  :items="disasterCategoryList"
                  :item-value="item=>item.id"
                  :item-text="item=>item.translation.name"
                  :label="$t('Event Type')"
                  v-model="disaster.disaster_category_id"
                  :hint="$t('Mandatory')"
                  :rules="selectRules"
                  persistent-hint
                >
                   <template v-slot:item="{ item }">
                    <div>{{ getTranslation(item.translation.name) }}</div>
                  </template>
                </v-select>
                <div v-if="form_type == 'viewForm'">
                  <p class="font-weight-light">{{ $t('Event Type') }}</p>
                  <p class="text-h4 text--primary">{{ disaster.disaster_category.translation.name }}</p>
                </div>
              </v-col>
            </v-row>
            <!--<v-row>
              <v-col
                cols="12"
                sm="4"
              >
                <v-text-field 
                  :hint="$t('Mandatory')"
                  :rules="nameRules"
                  persistent-hint
                  v-if="form_type == 'addForm' || form_type == 'editForm'"
                  :label="$t('Name')"
                  required
                  v-model="disaster.name_en"
                ></v-text-field>
                <div v-if="form_type == 'viewForm' ">
                  <p>{{ $t('Name') }}</p>
                  <p class="text-h4 text--primary">{{disaster.name_en}}</p>
                </div>
              </v-col>
            </v-row>-->

            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
              <v-autocomplete
                  v-if="form_type == 'addForm'"
                  :items="provinceList"
                  :item-value="item=>item.id"
                  :item-text="item=>item.translation.name"
                  :label="$t('Province')"
                  v-model="disaster.disaster_provinces"
                  multiple
                  :rules="provinceRules"
                  :hint="$t('Mandatory')"
                  persistent-hint
                >
                  <template v-slot:item="{ item }">
                    <div>{{ getTranslation(item.translation.name) }}</div>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-if="form_type == 'editForm'"
                  :items="provinceList"
                  :item-value="item=>item.id"
                  :item-text="item=>item.translation.name"
                  :label="$t('Province')"
                  v-model="disasterProvinceInit"
                  multiple
                  :hint="$t('Mandatory')"
                  persistent-hint
                >
                  <template v-slot:item="{ item }">
                    <div>{{ getTranslation(item.translation.name) }}</div>
                  </template>
                </v-autocomplete>
                <div v-if="form_type == 'viewForm' ">
                  <p>{{ $t('Province') }}</p>
                  <p class="text-h4 text--primary" v-for="(prov,province_id) in disaster.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.province.translation.name) }}</p>
                </div> 
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-if="form_type == 'addForm'"
                  :items="districtListbyProvince"
                  :item-value="item=>item.id"
                  :item-text="item=>item.translation.name"
                  :label="$t('District')"
                  v-model="disaster.disaster_districts"
                  multiple
                >
                  <template v-slot:item="{ item }">
                    <div>{{ getTranslation(item.translation.name) }}</div>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-if="form_type == 'editForm'"
                  :items="districtListbyProvince"
                  :item-value="item=>item.id"
                  :item-text="item=>item.translation.name"
                  :label="$t('District')"
                  v-model="disasterDistrictInit"
                  multiple
                >
                  <template v-slot:item="{ item }">
                    <div> {{ getTranslation(item.translation.name) }}</div>
                  </template>
                </v-autocomplete>
                <div v-if="form_type == 'viewForm' ">
                  <p>{{ $t('District') }}</p>
                  <p class="text-h4 text--primary" v-for="(dist,district_id) in disaster.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.district.translation.name) }} ( {{ getTranslation('Province') }}: {{ getTranslation(dist.district.province.translation.name) }} )</p>
                </div> 
              </v-col>
              <!--<v-col
                cols="12"
                sm="4"
              >
                <v-autocomplete
                  v-if="form_type == 'addForm'"
                  :items="villageList"
                  :item-value="item=>item.id"
                  :item-text="item=>item.translation.name"
                  :label="$t('Village')"
                  v-model="disaster.disaster_villages"
                  multiple
                >
                  <template v-slot:item="{ item }">
                    <div>{{ getTranslation(item.translation.name) }}</div>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-if="form_type == 'editForm'"
                  :items="villageList"
                  :item-value="item=>item.id"
                  :item-text="item=>item.translation.name"
                  :label="$t('Village')"
                  v-model="disasterVillageInit"
                  multiple
                >
                  <template v-slot:item="{ item }">
                    <div> {{ getTranslation(item.translation.name) }}</div>
                  </template>
                </v-autocomplete>
                <div v-if="form_type == 'viewForm' ">
                  <p>{{ $t('Village') }}</p>
                  <p class="text-h4 text--primary" v-for="(vill,village_id) in disaster.disaster_villages" :key="vill.village_id">{{ getTranslation(vill.village.translation.name) }} ( {{ getTranslation('Province') }}: {{ getTranslation(vill.village.district.province.translation.name) }} )</p>
                </div> 
              </v-col>-->

            </v-row>
          </v-form>
        </material-card>
      </v-col>

      </v-container>
    </v-card-text>
    <v-card-actions v-if="form_type == 'addForm' || form_type == 'editForm'">
      <v-spacer></v-spacer>
      <v-btn
        class="close-button"
        text
        v-on:click="close_edit()"
      >
        {{ $t('Close') }}
        <v-dialog v-model="dialog_modal_message" persistent max-width="800px" :retain-focus="false">
          <MessageAlert 
              v-if="dialog_modal_message" 
              :messageProps="$store.state.messages.close" 
              :cancelProps="$store.state.messages.no" 
              :validationProps="$store.state.messages.yes" 
              :dialog.sync="dialog_modal_message" 
              @answerModal="getModalAnswer"
          />
        </v-dialog>
      </v-btn>
      <v-btn
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
        v-if="disaster 
              && disaster.year_id
              && disaster.disaster_category_id
              && disaster.disaster_provinces
              && disaster.disaster_provinces.length !== 0"
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="form_type == 'viewForm' ">
      <v-spacer></v-spacer>
      <v-btn
        class="close-button"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn v-if="$store.state.auth.user.user_functions[3].user_type_id !== 1" class="small" color="success" v-bind="attrs" v-on="on" v-on:click="update(disaster)">
        <v-icon>mdi-update</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'DisasterForm',
    props: {
      disasterProps: {
        type: Object
      },
      formType: {
        type: String
      }
    },
    data: () => ({
      dialog_modal_message: false,
      dialog_add: false,
      disaster: {},
      form_type: '',
      disasterProvinceInit: [],
      disasterDistrictInit: [],
      districtListbyProvince: []
      //disasterVillageInit: []
    }),
    computed: {
        disasterCategoryList() {
          return this.$store.state.referentials.disasterCategoryList;
        },
        yearList() {
          return this.$store.state.referentials.yearList;
        },
        provinceList() {
          return this.$store.state.referentials.provinceList;
        },
        districtList() {
          return this.$store.state.referentials.districtList;
        },
        /*villageList() {
          return this.$store.state.referentials.villageList;
        },  */
    },
    created: function(){
      //https://v15.vuetifyjs.com/en/components/forms/ 
      //this.nameRules = [ v => !!v || this.getTranslation('Name is required') ];
      this.selectRules = [ v => !!v || this.getTranslation('At least 1 Information is required') ];
      this.provinceRules = [ v => v.length > 0 || this.getTranslation('At least 1 Province is required') ];
    },
    mounted: function(){
      this.form_type = this.formType;
      this.disaster = this.disasterProps;
      this.$store.dispatch('referentials/getDisasterCategoryList');
      this.$store.dispatch('referentials/getYearList');
      this.$store.dispatch('referentials/getProvinceList');
      this.$store.dispatch('referentials/getDistrictList');
      //this.$store.dispatch('referentials/getVillageList');
    },
    watch: {
      'disaster.disaster_provinces': function(value){
        this.districtListbyProvince = this.districtList.filter(dis => value.includes(dis.province_id));
      },
      disasterProvinceInit: function(value){
        this.districtListbyProvince = this.districtList.filter(dis => value.includes(dis.province_id));
      },
    },
    methods: {
      getTranslation(val) {
        return this.$t(val);
      },
      close: function(){
        this.form_type = 'viewForm';
        this.$store.dispatch('disasters/getDisasters');
        this.$emit('update:dialog', false);
      },
      close_edit: function(){
        this.dialog_modal_message = true;
      },
      getModalAnswer(value){
        if(value){
          this.form_type = 'viewForm';
          this.$store.dispatch('disasters/getDisasters');
          this.$emit('update:dialog', false);
        }
      },
      save: function(){

          if(this.form_type == 'addForm'){
            //this.disaster.affectedRoadList = this.affectedRoadList;
            this.$store.dispatch('disasters/addDisaster',this.disaster);
          }
          if(this.form_type == 'editForm'){
            this.$store.dispatch('disasters/updateDisaster',{
              'disaster': this.disaster, 
              'disasterProvinceInit': this.disasterProvinceInit, 
              'disasterDistrictInit': this.disasterDistrictInit//, 
              //'disasterVillageInit': this.disasterVillageInit
            });
          }
          this.$store.dispatch('disasters/getDisasters');
          this.$emit('update:dialog', false)

      },
      update: function(){
        this.form_type = 'editForm';
        this.disasterProvinceInit = [];
        this.disasterDistrictInit = [];
        //this.disasterVillageInit = [];
        this.districtListbyProvince = this.districtList.filter(dis => 
            this.disaster.disaster_provinces.some(dp => dp.province_id === dis.province_id)
        );
        //LOCATION - Initialisation des valeurs de v-autocomplete multiple element
        this.disaster.disaster_provinces.forEach(province => this.disasterProvinceInit.push(province.province_id));
        this.disaster.disaster_districts.forEach(district => this.disasterDistrictInit.push(district.district_id));
        //this.disaster.disaster_villages.forEach(village => this.disasterVillageInit.push(village.village_id));
      }
    }
  }
</script>
<style type="text/css">

  .affected-asset-subtitle, .affected-asset-label {
    text-align: center;
    margin: auto;
    font-size: 0.9rem !important;
    font-weight: 400;
  }

</style>
